
export const MAX_MONTHS = 6 * 12

export const periodMonthsSet = (month: number | null) => {
    return month !== null && month > 0
}

export const calculateObservationalPeriodMonths = (fromDate: string | undefined, toDate: string | undefined): number => {
    if (fromDate === undefined || toDate === undefined) {
        return 0
    }

    const from = new Date(`${fromDate.split('/')[1]}-${fromDate.split('/')[0]}-01`)
    const to = new Date(`${toDate.split('/')[1]}-${toDate.split('/')[0]}-01`)
    return ((to.getFullYear() - from.getFullYear()) * 12)
        + to.getMonth() - from.getMonth()
        + 1
}

export const calculateTotalPatientCount = (response?: { [key: string]: any }): number | undefined => {
    if (response?.tracker === undefined) {
        return undefined
    }

    return undefined
}